<template>
  <div class="form-single-fragment" style="position: relative;">
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
<!--      <el-button type="primary" :size="defaultFormItemSize"  @click="onAddClick()" v-if="checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')">-->
<!--        保存-->
<!--      </el-button>-->
    </label>
    <el-tabs v-model="activeName" type="card" >
      <el-tab-pane label="工作内容" name="first">
    <el-form ref="temporaryWorkForm" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="150px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="工作标题" prop="TemporaryWork.workSubject">
            <el-input class="input-item"   v-model="formData.TemporaryWork.workSubject"
              :clearable="true" placeholder="工作标题"
                      :readonly="!checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="要求完成时间" prop="TemporaryWork.requiredTime">
            <el-date-picker class="input-item" v-model="formData.TemporaryWork.requiredTime" :clearable="true"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd 00:00:00"
                            type="date" align="left"
                            placeholder="要求完成时间"
                            :readonly="!checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="工作内容" prop="TemporaryWork.workContent">
            <el-input class="input-item" type="textarea" :rows="2" v-model="formData.TemporaryWork.workContent"
              :clearable="true" placeholder="工作内容"  :readonly="!checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="图片" prop="TemporaryWork.picture">

            <el-upload
              class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/app/temporaryWork/upload')"
              :data="{fieldName: 'picture', asImage: true}"
              :on-success="onPictureUploadSuccess"
              :on-remove="onPictureRemoveFile"
              :on-error="onUploadError"
              :show-file-list="true"
              :on-preview="handlePreview"
              :limit="temporaryWorkForm.picture.impl.maxCount"
              :on-exceed="onUploadLimit"
              :file-list="temporaryWorkForm.picture.impl.fileList"
              :disabled="!checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')"
              list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>

          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作附件" prop="TemporaryWork.attachedFiles">
            <el-upload  name="uploadFile" :headers="getUploadHeaders" multiple
                        :action="getUploadActionUrl('/admin/app/temporaryWork/upload')"
                        :data="{fieldName: 'attachedFiles', asImage: false}"
                        :on-success="onAttachedFilesUploadSuccess"
                        :on-remove="onAttachedFilesRemoveFile"
                        :on-error="onUploadError" :on-exceed="onUploadLimit"
                        :limit="temporaryWorkForm.attachedFiles.impl.maxCount"
                        :file-list="temporaryWorkForm.attachedFiles.impl.fileList"
                        :disabled="!checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')"
                        :show-file-list="false">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
            <div v-if="temporaryWorkForm.attachedFiles.impl.fileList && temporaryWorkForm.attachedFiles.impl.fileList[0] != null" style="position: relative">
              <div v-for="(item,index) in temporaryWorkForm.attachedFiles.impl.fileList" :key="item.url"
                   style="display:flex;margin-top: 5px;">
                <div> {{item.name}}</div>
                <div style="margin-left: 15px;display: inline-flex">

                  <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                  <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                  <el-button type="primary" v-if="checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')"
                             @click="deleteAttachedFiles(item,temporaryWorkForm.attachedFiles.impl.fileList,index)">删除
                  </el-button>
                </div>

              </div>
            </div>
            <template v-else>
              <a v-for="item in temporaryWorkForm.attachedFiles.impl.fileList" :key="item.url"
                 href="javascript:void(0);" @click="previewFile(item.url, item.filename)">
                {{item.name}}
              </a>
            </template>
          </el-form-item>
        </el-col>
        <el-col class="table-box gutter-bottom" :span="24">
          <el-row type="flex" justify="end" style="margin-bottom: 20px;">
            <el-button type="primary" :size="defaultFormItemSize" @click="onSelectUserClick()"
                       v-if="checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate') ||
                       userInfo.isSpecial==='2'">
              指派人员
            </el-button>
          </el-row>
          <el-table ref="courseChapter" :data="selectUserList" :size="defaultFormItemSize"
                    header-cell-class-name="table-header-gray"
          >
            <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"  />
            <el-table-column label="名称" prop="showName">
            </el-table-column>
            <el-table-column label="类型" >
              <template slot-scope="scope">
                <p v-if="scope.row.mobileUserType ===3">特派员</p>
                <p v-if="scope.row.mobileUserType ===4">联络员</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button @click.stop="onRowDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="userInfo.userId === scope.row.userId || userInfo.isSpecial==='1'">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize"  @click="onAddClick()" v-if="checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')">
              保存
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize"  @click="onAssign()"
                       v-if="userInfo.isSpecial==='2'">
              指派
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize"
                       v-if="(userInfo.isSpecial &&(userInfo.isSpecial==='2' ||
                       userInfo.isSpecial==='1'))"
                       @click="dialogFormVisible = true">
              反馈
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog title="反馈" :visible.sync="dialogFormVisible">
      <el-form :model="feedBackForm">
        <el-form-item label="反馈内容" label-width="120">
          <el-input v-model="feedBackForm.dealDesc" type="textarea" :rows="2"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="反馈附件" prop="TemporaryWork.attachedFiles">
          <el-upload  name="uploadFile" :headers="getUploadHeaders" multiple
                      :action="getUploadActionUrl('/admin/app/temporaryWorkFeedback/upload')"
                      :data="{fieldName: 'attachedFiles', asImage: false}"
                      :on-success="onAttachedFilesUploadSuccess2"
                      :on-remove="onAttachedFilesRemoveFile2"
                      :on-error="onUploadError" :on-exceed="onUploadLimit"
                      :limit="attachedFiles2.impl.maxCount"
                      :file-list="attachedFiles2.impl.fileList"
                      :show-file-list="false">
            <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
          </el-upload>
          <div v-if="attachedFiles2.impl.fileList && attachedFiles2.impl.fileList[0] != null" style="position:
          relative">
            <div v-for="(item,index) in attachedFiles2.impl.fileList" :key="item.url"
                 style="display:flex;margin-top: 5px;">
              <div> {{item.name}}</div>
              <div style="margin-left: 15px;display: inline-flex">

                <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                <el-button type="primary"
                           @click="deleteAttachedFiles2(item,attachedFiles2.impl.fileList,index)">删除
                </el-button>
              </div>

            </div>
          </div>
          <template v-else>
            <a v-for="item in attachedFiles2.impl.fileList" :key="item.url"
               href="javascript:void(0);" @click="previewFile(item.url, item.filename)">
              {{item.name}}
            </a>
          </template>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onFeedBack()">确 定</el-button>
      </div>
    </el-dialog>

      </el-tab-pane>
      <el-tab-pane label="反馈情况" name="second" v-if="formData.TemporaryWork.id">
        <temporaryWorkFeedbackList :workId="formData.TemporaryWork.id"></temporaryWorkFeedbackList>
      </el-tab-pane>
    </el-tabs>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { TemporaryWorkController, DictionaryController, TemporaryWorkFeedbackController} from '@/api';
import selectUser from '@/components/userSelect';
import temporaryWorkFeedbackList from './temporaryWorkFeedback';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    temporaryWorkFeedbackList
  },
  name: 'temporaryWorkForm',
  props: {
    id: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      activeName: 'first',
      dialogFormVisible: false,
      imgViewerVisible: false,
      imgList: [],
      selectUserList: [],
      formData: {
        TemporaryWork: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          createUserName: undefined,
          workType: undefined,
          workSubject: undefined,
          workContent: undefined,
          attachedFiles: undefined,
          dealStatus: undefined,
          picture: undefined,
          requiredTime: undefined,
          isDatasourceInit: false,
          selectUserName: [],
          selectUserId: []
        }
      },
      rules: {
        'TemporaryWork.workSubject': [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        'TemporaryWork.workContent': [
          {required: true, message: '请输入内容', trigger: 'blur'}
        ],
        'TemporaryWork.requiredTime': [
          {required: true, message: '请输入要求完成时间', trigger: 'blur'}
        ],
        'TemporaryWork.selectUserName': [
          {required: true, message: '请选择人员', trigger: 'blur'}
        ]
      },
      temporaryWorkForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        attachedFiles: {
          impl: new UploadWidget(1)
        },
        picture: {
          impl: new UploadWidget(1)
        },
        selectUser: {
          impl: new TableWidget(this.loadSelectUserWidgetData, true, false, false, 'showOrder', 1)
        },
        isInit: false
      },
      feedBackForm: {
        dealDesc: undefined
      },
      attachedFiles2: {
        impl: new UploadWidget(1)
      },
      userInfo: {}
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    /**
     * 更新临时性工作表单
     */
    refreshTemporaryWorkForm (reloadData = false) {
      this.loadTemporaryWorkData().then(res => {
        if (!this.temporaryWorkForm.isInit) {
          // 初始化下拉数据
        }
        this.temporaryWorkForm.isInit = true;
      })
    },
    loadTemporaryWorkData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.TemporaryWork.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          TemporaryWorkController.view(this, params).then(res => {
            this.formData.TemporaryWork = {...res.data, isDatasourceInit: true};
            this.selectUserList = res.data.selectUserId ? res.data.selectUserId : []
            console.log(this.formData.TemporaryWork)
            let attachedFilesDownloadParams = {
              id: this.formData.TemporaryWork.id,
              fieldName: 'attachedFiles',
              asImage: false
            }
            this.temporaryWorkForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.TemporaryWork.attachedFiles, attachedFilesDownloadParams);

            let pictureDownloadParams = {
              id: this.formData.TemporaryWork.id,
              fieldName: 'picture',
              asImage: true
            }
            this.temporaryWorkForm.picture.impl.fileList = this.parseUploadData(this.formData.TemporaryWork.picture, pictureDownloadParams);
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.TemporaryWork.isDatasourceInit = true;
          resolve();
        }
      });
    },
    loadSelectUserWidgetData () {

    },
    /**
     * 新增
     */
    onAddClick () {
      if (!this.selectUserList || this.selectUserList.length === 0) {
        this.$message.error('请选择人员');
        return;
      }
      // this.selectUserList.forEach((item) => {
      //   this.formData.TemporaryWork.selectUserId.push(item.id)
      // })
      this.formData.TemporaryWork.selectUserId = this.selectUserList
      this.$refs.temporaryWorkForm.validate((valid) => {
        if (!valid) return;
        let params = {
          temporaryWorkDto: {
            // createUserId: this.formData.TemporaryWork.createUserId,
            // createTime: this.formData.TemporaryWork.createTime,
            // updateUserId: this.formData.TemporaryWork.updateUserId,
            // workType: this.formData.TemporaryWork.workType,
            // workSubject: this.formData.TemporaryWork.workSubject,
            // workContent: this.formData.TemporaryWork.workContent,
            // attachedFiles: this.formData.TemporaryWork.attachedFiles,
            // picture: this.formData.TemporaryWork.picture,
            // requiredTime: this.formData.TemporaryWork.requiredTime
            ...this.formData.TemporaryWork
          }
        };
        if (params.temporaryWorkDto.id) {
          TemporaryWorkController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        } else {
          TemporaryWorkController.add(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        }
      });
    },
    onFeedBack () {
      this.feedBackForm.workId = this.formData.TemporaryWork.id
      if (!this.feedBackForm.dealDesc) {
        this.$message.error('请填写反馈内容');
        return;
      }
      let params = {
        temporaryWorkFeedbackDto: {
          ...this.feedBackForm
        }
      };
      TemporaryWorkFeedbackController.update(this, params).then(res => {
        this.$message.success('反馈成功');
        this.onCancel(true);
      }).catch(e => {});
    },
    onAssign () {
      if (!this.selectUserList || this.selectUserList.length === 0) {
        this.$message.error('请选择人员');
        return;
      }
      let params = {sysUsers: this.selectUserList, workId: this.formData.TemporaryWork.id}

      TemporaryWorkFeedbackController.assign(this, params).then(res => {
        this.$message.success('指派成功');
        this.onCancel(true);
      }).catch(e => {});
    },
    onResume () {
      this.refreshTemporaryWorkForm(true);
    },
    initFormData () {
    },
    /**
     * 工作附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.temporaryWorkForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.TemporaryWork.attachedFiles = this.fileListToJson(this.temporaryWorkForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    /**
     * 移除工作附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.temporaryWorkForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.TemporaryWork.attachedFiles = this.fileListToJson(this.temporaryWorkForm.attachedFiles.impl.fileList);
    },

    /**
     * 工作附件上传成功
     */
    onAttachedFilesUploadSuccess2 (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.attachedFiles2.impl.onFileChange(file, fileList);
        this.feedBackForm.attachedFiles = this.fileListToJson(this.attachedFiles2.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    deleteAttachedFiles2 (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile2(file, fileList)
    },
    /**
     * 移除工作附件
     */
    onAttachedFilesRemoveFile2 (file, fileList) {
      this.attachedFiles2.impl.onFileChange(file, fileList);
      this.feedBackForm.attachedFiles = this.fileListToJson(this.attachedFiles2.impl.fileList);
    },

    /**
     * 图片上传成功
     */
    onPictureUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.temporaryWorkForm.picture.impl.onFileChange(file, fileList);
        this.formData.TemporaryWork.picture = this.fileListToJson(this.temporaryWorkForm.picture.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除图片
     */
    onPictureRemoveFile (file, fileList) {
      this.temporaryWorkForm.picture.impl.onFileChange(file, fileList);
      this.formData.TemporaryWork.picture = this.fileListToJson(this.temporaryWorkForm.picture.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    onSelectUserClick () {
      let that = this
      let params = {
        selectUserId: this.formData.TemporaryWork.selectUserId
      };

      this.$dialog.show('人员设置', selectUser, {
        area: ['1200px', '700px']
      }, params).then(res => {
        console.log(res)
        // that.formData.TemporaryWork.selectUserName = res.nameList.join(',')
        // that.formData.TemporaryWork.selectUserId = res.idList
        that.selectUserList.push(...res.multipleSelection)
        console.log(that.selectUserList)
        this.$forceUpdate()

        // this.refreshFormSysDeptPost();
      }).catch(e => {});
    },
    onRowDeleteClick (row) {
      this.$confirm('确认删除？').then(res => {
        this.selectUserList = this.selectUserList.filter(item => {
          return item.userId !== row.userId;
        });
      }).catch(e => {});
    },

    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        TemporaryWork: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          createUserName: undefined,
          workType: undefined,
          workSubject: undefined,
          workContent: undefined,
          attachedFiles: undefined,
          dealStatus: undefined,
          picture: undefined,
          requiredTime: undefined,
          selectUserName: [],
          selectUserId: [],
          isDatasourceInit: false
        }
      }
      this.feedBackForm = {
        attachedFiles: undefined,
        dealDesc: undefined
      }
    },
    formInit () {
      this.refreshTemporaryWorkForm();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.userInfo = this.$store.state.userInfo

    this.formInit();
  },
  watch: {
  }
}
</script>
